import { handleResponseOld, makeGet } from './helpers';

type TransformParams = {
    invoice: any;
    results: any;
    shippingAddress: any;
};
const transform = ({ invoice = {}, results = [], shippingAddress = {} }: TransformParams) => {
    const {
        balance_due_subtotal: balanceDue,
        buyers_premium_total: buyersPremium,
        currency,
        id,
        invoice_total: invoiceTotal,
        is_sent: sent,
        item_total: itemTotal,
        other_charges: otherCharges,
        payments,
        payments_total: paymentsTotal,
        sales_tax,
        shipping_charge,
    } = invoice;

    const {
        address_line1: address,
        address_line2: address2,
        city,
        country,
        phone_number: mobileNumber,
        postal_code: zip,
        shipping_option_type: shippingMethod,
        state,
    } = shippingAddress || {};

    const items = results.map((item) => {
        return {
            catalogId: item.catID,
            imageVersion: item.imageVersion,
            itemId: item.lotID,
            salePrice: item.sale_price,
            sellerId: item.houseID,
            sellerName: item.name,
            title: item.title,
        };
    });

    return {
        data: {
            invoice: {
                balanceDue,
                buyersPremium,
                currency: currency?.cur_code,
                id,
                invoiceTotal,
                itemTotal,
                otherCharges,
                payments,
                paymentsTotal,
                salesTax: Number(sales_tax),
                sent: Boolean(sent),
                shipping: Number(shipping_charge),
            },
            invoiceAddress: {
                address,
                address2,
                city,
                country,
                mobileNumber,
                state,
                zip,
            },
            items,
            shippingMethod,
        },
        message: id ? 'Successfully retrieved the invoice.' : 'Error getting the invoice',
        success: Boolean(id),
    };
};

/**
 * @category Mainhost API
 * @see fetchInvoice
 */
type FetchInvoiceParams = {
    authToken: string;
    bidderId: number;
    catalogId: number;
    deployment: string;
};
/**
 * Gets invoice info via Get to Mainhost service's payment API
 * @function fetchInvoice
 * @category Mainhost API
 * @param {FetchInvoiceParams}
 * @see https://mainhost-DEPLOYMENT.liveauctioneers.com/api/bidders/${bidderId}/wonitems/catalogs/${catalogId}
 * @see https://github.com/LIVEauctioneers/mainhost-prod/blob/master/httpdocs/api/bidders.php#L198
 */
const fetchInvoice = ({ authToken, bidderId, catalogId, deployment }: FetchInvoiceParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/wonitems/catalogs/${catalogId}`,
            queryParams: { client_version: '5.0', page: 1, pagesize: 1250 },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
    });

export default {
    fetchInvoice,
};
